import { Stack } from "@mui/material";
import { useCurrentDate } from "@src/appV2/lib/utils/useCurrentDate";
import { CurrentShiftStage } from "@src/appV2/redesign/Shift/constants";
import { getShiftCurrentStage } from "@src/appV2/redesign/Shift/WorkerShift/getShiftCurrentStage";
import { type Shift } from "@src/appV2/Shifts/Shift/types";
import { differenceInMinutes, parseISO } from "date-fns";

import { BreakActions } from "./BreakActions";
import { ClockOutAction } from "./ClockOutAction";

const SHOW_CLOCK_OUT_THRESHOLD_IN_MINUTES = 60;

interface TimekeepingActionsProps {
  shift: Shift;
  onStartBreak: () => void;
  onEndBreak: () => void;
  onClockOut: () => void;
  onSkipBreak: () => void;
  showBreakActivity: boolean;
}

export function TimekeepingActions(props: TimekeepingActionsProps) {
  const { shift, onStartBreak, onEndBreak, onClockOut, onSkipBreak, showBreakActivity } = props;

  const currentDate = useCurrentDate(1000);
  const shiftEndDate = parseISO(shift.end);

  const currentStage = getShiftCurrentStage(shift);
  const isOnBreak = currentStage === CurrentShiftStage.BREAK_STARTED;
  const hasEndedBreak = currentStage === CurrentShiftStage.BREAK_ENDED;
  const hasSkippedBreak = currentStage === CurrentShiftStage.BREAK_SKIPPED;
  const shouldShowClockOut =
    !showBreakActivity ||
    hasEndedBreak ||
    hasSkippedBreak ||
    differenceInMinutes(shiftEndDate, currentDate) < SHOW_CLOCK_OUT_THRESHOLD_IN_MINUTES;

  return (
    <Stack
      sx={{
        position: "fixed",
        bottom: 70,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1,
        gap: 1,
        alignItems: "center",
      }}
    >
      {!shouldShowClockOut && showBreakActivity && (
        <BreakActions
          isOnBreak={isOnBreak}
          hasEndedBreak={hasEndedBreak}
          hasSkippedBreak={hasSkippedBreak}
          onStartBreak={onStartBreak}
          onEndBreak={onEndBreak}
          onSkipBreak={onSkipBreak}
        />
      )}

      {shouldShowClockOut && <ClockOutAction onClockOut={onClockOut} />}
    </Stack>
  );
}
